module.exports = __webpack_public_path__ + "img/hero-bg-xxl.f0e2126.webp";